import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import RegistrationForm from "../RegistrationForm/index";
import { LoadID, changeData, RegEditSave } from "../../../actions";
import Spinner from "../../atoms/Spinner";
import { Typography, Paper, Container } from "@material-ui/core";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { Redirect } from "react-router-dom";

const styles = theme => ({
  error: {
    color: "red",
    marginTop: theme.spacing(2)
  },
  button: {
    marginTop: theme.spacing(2)
  }
});

export class RegistrationFormEdit extends Component {
  constructor(props) {
    super();
    this.handleSave = this.handleSave.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  componentDidMount() {
    const { User } = this.props;
    //console.log('User.UserID',User.UserID)
    this.props.LoadID(User.UserID);
    this.props.changeData("personal_information", {
      full_first_name: User.Identity.FirstName,
      full_last_name: User.Identity.LastName,
      street_address: User.Address.Street,
      country: User.Address.Country,
      zip: User.Address.ZIP,
      city: User.Address.City,
      nationality: User.Identity.Nationality,
      birthdate: User.Identity.DateOfBirth,
      email: User.Emails[0].Email
    });
    this.props.changeData("document", {
      document_type: User.IdentityDocuments.Type,
      document_id: User.IdentityDocuments.ID,
      document_images: {
        frontside: null,
        backside: null,
        selfi: null
      }
    });
  }

  handleSave(data) {
    this.props.changeData(data.section, data.data);
  }
  handleNext(data = null) {
    this.props.RegEditSave();
  }

  render() {
    const { classes, state } = this.props;
    const data = {
      personal_information: this.props.personal_information,
      confirmation: this.props.confirmation,
      document: this.props.document
    };
    if (this.props.document.fetching_error) {
      return <Redirect to="/error/authentication" />;
    }
    if (state.saveCounter > 0)
      return (
        <Paper square elevation={0} align="center">
          <Typography variant="h5">
            The changes to your personal information have been saved.
          </Typography>
          <Typography>
            It might take some time for the changes to become visible in the
            dasboard view.
          </Typography>
          <Button
            color="primary"
            variant="outlined"
            component={Link}
            to="/dashboard"
            className={classes.button}
          >
            Dashboard
          </Button>
        </Paper>
      );
    if (state.isSaving.frontside === true)
      return (
        <Paper square elevation={0} align="center">
          <Spinner />
          <Typography variant="h5">
            Saving Personal Information...
          </Typography>{" "}
        </Paper>
      );

    if (
      data.document.document_images.frontside === null ||
      data.document.document_images.selfi === null ||
      (data.document.document_type === "ID Card" &&
        data.document.document_images.frontside === null)
    )
      return (
        <Paper square elevation={0} align="center">
          <Spinner />
          <Typography variant="h5">
            Loading Personal Information...
          </Typography>{" "}
        </Paper>
      );

    return (
      <Container>
        <div>
          <Typography variant="h5">Personal Information Update</Typography>
          <RegistrationForm
            data={data}
            save={this.handleSave}
            next={this.handleNext}
            edit
          />
          {state.SavingErrorCounter > 0 && (
            <Typography className={classes.error}>
              Failed to save the changes. Please try again.
            </Typography>
          )}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  User: state.User,

  personal_information: state.personal_information,
  confirmation: state.confirmation,
  document: state.document,
  state: state
});

const mapDispatchToProps = dispatch => {
  return {
    LoadID: userid => dispatch(LoadID(userid)),
    changeData: (section, data) => dispatch(changeData(section, data)),
    RegEditSave: () => dispatch(RegEditSave())
    // adminSearchUser: searchtext => dispatch(adminSearchUser(searchtext))
  };
};

const RegistrationFormEditRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationFormEdit);

export default withStyles(styles)(RegistrationFormEditRedux);
